'use strict';

import 'waypoints/lib/noframework.waypoints.min.js';
import {
  TimelineMax
} from 'gsap';
window.TimelineMax = TimelineMax;

// # myaward-artist - 나와 아티스트 <좋아하는 1명>
const _timeLineForArtistTypeCase1 = ($currentContents) => { 
  const $artistImg = $currentContents.find('.myreport-artist-img'),
    $artistName = $currentContents.find('.myreport-artist-name'),
    $tag1 = $currentContents.find('.myreport-artist-tag.tag1'),
    $tag2 = $currentContents.find('.myreport-artist-tag.tag2'),
    $tag3 = $currentContents.find('.myreport-artist-tag.tag3');

  const tl = new TimelineMax({ delay: 0.1 });

  tl.add('all')
    .staggerFrom([$artistImg, $artistName, $tag1, $tag2, $tag3], 0.8, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all');

  tl.pause();

  return tl;
};
// # myaward-artist - 나와 아티스트 <좋아하는 3명>
const _timeLineForArtistTypeCase3 = ($currentContents) => { 
  const $artistThumb1 = $currentContents.find('.myreport-artist-team.team1'),  
    $artistThumb2 = $currentContents.find('.myreport-artist-team.team2'),  
    $artistThumb3 = $currentContents.find('.myreport-artist-team.team3'),  
    $tag1 = $artistThumb1.find('.myreport-artist-tag'),
    $tag2 = $artistThumb2.find('.myreport-artist-tag'),
    $tag3 = $artistThumb3.find('.myreport-artist-tag');

  const tl = new TimelineMax({ delay: 0.3 });

  tl.add('all')
    .staggerFrom([$artistThumb1, $artistThumb2, $artistThumb3], 1, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all')
    .staggerFrom([$tag1, $tag2, $tag3], 1, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all+=0.5');

  tl.pause();

  return tl;
};

window.aniType = {};

// # myaward-artist - 나와 아티스트 <좋아하는 1명>
aniType.artistTypeCase1 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.artistTypeCase1.tl) {
      aniType.artistTypeCase1.tl = _timeLineForArtistTypeCase1($targetContents)
      aniType.artistTypeCase1.tl.play();
    } else {
      aniType.artistTypeCase1.tl.restart(true, false);
    }
  }
}
// # myaward-artist - 나와 아티스트 <좋아하는 3명>
aniType.artistTypeCase3 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.artistTypeCase3.tl) {
      aniType.artistTypeCase3.tl = _timeLineForArtistTypeCase3($targetContents)
      aniType.artistTypeCase3.tl.play();
    } else {
      aniType.artistTypeCase3.tl.restart(true, false);
    }
  }
}

//my pick
$(function() {
  //delete button
  $('.cont-mypick .item-search input[type="text"]').on('keyup', function() {
    if($(this).val().length > 0) {
      $(this).siblings('.btn-del').addClass('on');
    }
  });
  $('.cont-mypick .item-search .btn-del').on('click', function() {
    $(this).removeClass('on');
    $(this).siblings('input[type="text"]').val('');
  });
  $('.mypick-cont .item-box .btn-add').on('click', function() {
    $('#song').modal();
    $(this).closest('.item-box').addClass("item-select");
    $('.mypick-cont .btn-complete').addClass("on");
  });
  $('.mypick-cont .best-artist .btn-add').on('click', function() {
    $('#song').modal('hide');
    $('#artist').modal();
  });
  $('.mypick-cont .item-box .btn-del').on('click', function() {
    $(this).closest('.item-box').removeClass("item-select");
    $('.mypick-cont .btn-complete').removeClass("on");
  });
});

setTimeout(function () {
  $(".mypick-bg").addClass("bg-ani");
}, 500);